import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3 pt-5 mt-5 p-component flex justify-content-between app-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "px-2 text-sx font-bold" }, " POD Admin Web Application 2021 HTCPL© ", -1),
    _createElementVNode("div", { class: "px-2" }, [
      _createElementVNode("img", {
        src: "https://www.haadthip.com/assets/images/logo.svg",
        style: {"width":"120px"},
        alt: ""
      })
    ], -1)
  ])))
}